import { Link } from "react-router-dom";

interface BrandMarkProps {
  compact?: boolean;
}

export default function BrandMark({ compact = false }: BrandMarkProps) {
  return (
    <Link
      to="/"
      className={`brand-mark brand-mark-empty ${compact ? "brand-mark-compact" : ""}`}
      aria-label="Dalila Di Maria home"
    >
      <span className="sr-only">Dalila Di Maria</span>
    </Link>
  );
}
